import { findMatchingVariant } from '@/util/findMatchingProductVariant';
import { isProductConfigurable } from '@/util/isProductConfigurable';
import { useMemo } from 'react';

const OUT_OF_STOCK_CODE = 'OUT_OF_STOCK';
const IN_STOCK_CODE = 'IN_STOCK';

export const getIsOutOfStock = (product, optionCodes, optionSelections) => {
  const { stock_status, variants } = product;

  const isConfigurable = isProductConfigurable(product);

  const optionSelectionsArrray = Array.from(optionSelections.values());
  const optionsSelectedLength = optionSelectionsArrray.filter(value => {
    return !!value;
  }).length;

  let optionsSelected = false;

  if (optionsSelectedLength >= optionSelectionsArrray.length) {
    optionsSelected = true;
  }

  if (isConfigurable && optionsSelected) {
    const item = findMatchingVariant({
      optionCodes,
      optionSelections,
      variants,
    });

    if (!item) {
      return {
        isOutOfStock: true,
        isSoldOut: true,
      };
    }

    const { product } = item || {};

    const { presale_product } = product || {};

    const { status: isPreOrder } = presale_product || {};

    if (isPreOrder) {
      return {
        isOutOfStock: false,
        isSoldOut: false,
      };
    }

    const stockStatus = item?.product?.stock_status;

    return {
      isOutOfStock: stockStatus === OUT_OF_STOCK_CODE || !stockStatus,
      isSoldOut: false,
    };
  }

  return {
    isOutOfStock: stock_status === OUT_OF_STOCK_CODE,
    isSoldOut: false,
  };
};

export const useGetIsOutOfStock = ({
  product,
  optionCodes,
  optionSelections,
}: {
  product: any;
  optionCodes: any;
  optionSelections: any;
}) => {
  const { isOutOfStock, isSoldOut } = useMemo(
    () => getIsOutOfStock(product, optionCodes, optionSelections),
    [product, optionCodes, optionSelections],
  );

  return {
    isOutOfStock,
    isSoldOut,
  };
};
